import type { SportConfig } from '../types/sport';

export const badmintonConfig: SportConfig = {
  id: 'badminton',
  name: { ru: 'Бадминтон', en: 'Badminton' },
  icon: 'badminton',
  color: '#06B6D4',
  defaults: {
    teamMode: 'pairs',
    scoringMode: 'sets',
    maxParticipants: 2,
    durationMinutes: 45,
    hasParticipantLimit: true,
    participantStep: 2,
  },
  scoring: {
    type: 'sets',
    labels: { ru: ['Пара 1', 'Пара 2'], en: ['Pair 1', 'Pair 2'] },
  },
  shuffle: null,
  ratings: { enabled: true, scale: { min: 1, max: 5 }, anonymous: true },
  mvp: null,
  positions: null,
  supportsMultiMatch: false,
  playersPerTeam: 1,
};
